module.exports = __webpack_public_path__ + "static/media/landlix-d.cf741790.svg";